import "../Styles/Pages/Landing.css"
import ClassesL from "../Components/Landing/ClassesL";
import FAQsL from "../Components/Landing/FAQsL";
import SectionOneL from "../Components/Landing/SectionOneL";
import SodaqohL from "../Components/Landing/SodaqohL";
import SponsorL from "../Components/Landing/SponsorL";

const Landing = () => {
  return (
    <div className="landing">
      <SectionOneL />
      <ClassesL />
      <SponsorL />
      <SodaqohL />
      <FAQsL />
    </div>
  );
};

export default Landing;
